import React, { useEffect } from 'react';
import { Box, Typography } from '@mui/material';

const LocalInstanceIndicator: React.FC = () => {
  // Check if the current baseURL is pointing to localhost
  const isLocalInstance = window.location.origin.includes('localhost') || 
                         window.location.origin.includes('127.0.0.1') ||
                         window.location.origin.includes('0.0.0.0');

  useEffect(() => {
    if (isLocalInstance) {
      // Add top margin to body to prevent content overlap
      document.body.style.marginTop = '32px';
    } else {
      // Remove margin when not local
      document.body.style.marginTop = '0px';
    }

    // Cleanup function to remove margin when component unmounts
    return () => {
      document.body.style.marginTop = '0px';
    };
  }, [isLocalInstance]);

  if (!isLocalInstance) {
    return null;
  }

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 1000,
        backgroundColor: '#4caf50',
        color: 'white',
        padding: '4px 8px',
        textAlign: 'center',
        fontSize: '12px',
        fontWeight: 'bold',
        boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '8px',
        height: '24px'
      }}
    >
      <Box
        sx={{
          width: '8px',
          height: '8px',
          backgroundColor: 'white',
          borderRadius: '50%',
          animation: 'pulse 2s infinite'
        }}
      />
      <Typography variant="caption" sx={{ color: 'white', fontWeight: 'bold' }}>
        LOCALHOST INSTANCE - check backend database address
      </Typography>
      <style>
        {`
          @keyframes pulse {
            0% { opacity: 1; }
            50% { opacity: 0.5; }
            100% { opacity: 1; }
          }
        `}
      </style>
    </Box>
  );
};

export default LocalInstanceIndicator;
